import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { colors } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useSelector } from "react-redux"
import Skeleton from '@material-ui/lab/Skeleton';
import ExerciseCompleted from "./sessionCompleted";
import Toolbar from '@material-ui/core/Toolbar';
import Ballot from '@material-ui/icons/Ballot';

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        paddingRight: "5%"
    },
  headerBar: {
    backgroundColor: '#002D55',
    color: '#FFFFFF',
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    padding: 'clamp(8px, calc(1px + 0.55vw), 12px) clamp(10px, calc(2px + 0.625vw), 16px)',
    boxSizing: 'border-box',
  },
  headerIcon: {
    backgroundColor: '#002D55',
    margin: 'clamp(6px, 1vw, 15px)',
    height: 'clamp(24px, calc(14px + 1.2vw), 40px)',
    width: 'clamp(24px, calc(14px + 1.2vw), 40px)',
  },
  headerTitle: {
    fontSize: 'clamp(0.66rem, calc(0.291rem + 0.549vw), 0.95rem)',
    fontWeight: 700,
    paddingLeft: 5,
  },
    avatar: {
        backgroundColor: colors.orange[600],
        height: 50,
        width: 50
    }
}));

const simpleFormatter = (text, len) => {
    var i = 0;
    for(i = 0; i < text.length; i = i+len){
      if (i != 0) {
        const subString = text.slice(0, i).split("").reverse().join(""); // abc d -> d cba
        const splitIndex = subString.length - subString.indexOf(' ');
        text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
      }
    }
    return text;
  }

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com').replace(/\/$/, '');

const resolveExerciseImageUrl = (imageUrl) => {
  const value = String(imageUrl || '').trim();
  if (!value) {
    return '';
  }

  if (!/^https?:\/\//i.test(value)) {
    return value.startsWith('/') ? `${BACKEND_URL}${value}` : `${BACKEND_URL}/static-files/assessment-picture/${encodeURIComponent(value)}`;
  }

  try {
    const parsed = new URL(value);
    if ((parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1')
      && (parsed.pathname.startsWith('/static-files/') || parsed.pathname.startsWith('/media/') || parsed.pathname.startsWith('/static/'))) {
      return `${BACKEND_URL}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch (error) {
    return value;
  }

  return value;
};

const ExerciseImage = ({ exercise, height }) => {
  const [failedToLoad, setFailedToLoad] = useState(false);
  const imageUrl = resolveExerciseImageUrl(exercise.img || exercise.picture || exercise.image_url);

  if (!imageUrl || failedToLoad) {
    return <Skeleton variant="rect" width={210} height={118} />;
  }

  return (
    <img
      height={height * 0.10}
      alt={exercise.title}
      src={imageUrl}
      onError={() => setFailedToLoad(true)}
    />
  );
};

const SelectedPatientExercises = (props) => {
    const className = props.className
    const classes = useStyles();
    const { innerWidth: width, innerHeight: height } = window;
    const [token, _] = useState(useSelector(state => state.auth.token))
    return (
        <div className={classes.root}>
          <Grid container direction="column" justify="center" position="relative" className={classes.headerBar} style={{ marginLeft: 0 }}>
            <Toolbar >
              <Ballot className={classes.headerIcon} />
              <Typography className={classes.headerTitle}>
                Selected Patient's Exercises
              </Typography>
            </Toolbar>
          </Grid>
           <Grid container xs={12} md={12} lg={12} style={{ marginTop: 10, marginLeft: 17 }}>
                <Grid container direction="column" justify="center">
                <Grid item>
                    <Typography style={{color: "#002D55", marginBottom: "5%" }} variant="h5">
                      Planned exercises:
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container xs={12} justifyContent="center" direction="column"> 
                    {props.selectedPatientExercises.map(exercise => (
                        <Grid container direction="row"  style={{marginTop: 12, marginLeft: 15, marginRight: -35}} >
                          <Grid item>
                            <ExerciseImage exercise={exercise} height={height} />
                          </Grid>
                          {exercise ? (
                            <Grid item direction="row"  pr={2} style={{marginLeft: 18}}>
                              <Box style={{marginBottom: -47, marginLeft: -27}}><ExerciseCompleted checked={exercise.completed} /></Box>
                            <Typography  variant="body2" style={{marginBottom: -6}}>
                              <pre style={{ fontFamily: 'inherit' }}>
                                {simpleFormatter(exercise.title, 28)}
                              </pre>
                            </Typography>
                            <Typography display="block" variant="body2" color="textSecondary" >
                              {exercise.exerciseType}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" style={{marginTop: 5}}>
                              {`${exercise.sets} sets • ${exercise.repetitions} seconds`}
                            </Typography>
                           <Typography variant="body2" color="textSecondary" style={{marginTop: 5}}>
                              Yoga mat.
                            </Typography>
                          </Grid>
                        ) : (
                          <Box pt={0.5}>
                            <Skeleton /> 
                            <Skeleton width="100%" />
                          </Box>
                        )}
                        </Grid>
                    ))}
                    
                </Grid>
            </Grid>
        </div>
    );
};


export default SelectedPatientExercises;
